import axios from "axios";
import config from "../config";

const { endpoint, timeout, apiKey } = config.hartyAPI;

const defaultConfig = {
  baseURL: "https://harty-286207.an.r.appspot.com/api/",
  timeout,
};

export const coreAPIPublicClient = axios.create(defaultConfig);

const hartyAPIClient = axios.create({
  ...defaultConfig,
  headers: {
    "API-TOKEN": apiKey ? apiKey : "harty_api_token",
    "content-type": "application/json",
  },
});

export default hartyAPIClient;
